import { isbot } from "isbot";

const isHeadlessBrowser = (): boolean =>
	!!(
		navigator.webdriver ||
		// @ts-expect-error - TS2339
		window._phantom ||
		// @ts-expect-error - TS2339
		window.phantom ||
		// @ts-expect-error - TS2339
		window.callPhantom ||
		// @ts-expect-error - TS2339
		document.__selenium_unwrapped ||
		// @ts-expect-error - TS2339
		document.__webdriver_evaluate ||
		// @ts-expect-error - TS2339
		document.__driver_evaluate
	) || navigator.userAgent.includes("HeadlessChrome");

export const isBot = (): boolean =>
	isbot(navigator.userAgent) || isHeadlessBrowser();
